import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MagazineReader from "./MagazineReader";
import { makeAPI } from "../../services/api";

function pushRecentRead(issue) {
  if (!issue?._id) return;

  try {
    const current = JSON.parse(localStorage.getItem("magazine_recent_reads") || "[]");
    const next = [String(issue._id), ...current.filter((id) => String(id) !== String(issue._id))].slice(0, 12);
    localStorage.setItem("magazine_recent_reads", JSON.stringify(next));
  } catch {
    // no-op
  }
}

export default function MagazinePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const stateIssue = location.state?.issue;
  const [readerState, setReaderState] = useState({
    isLoading: true,
    canRead: false,
    error: ""
  });
  let storedIssue = null;

  try {
    storedIssue = JSON.parse(localStorage.getItem("selected_magazine_issue") || "null");
  } catch {
    storedIssue = null;
  }

  const issue = stateIssue || storedIssue;

  useEffect(() => {
    let active = true;

    async function validateReaderAccess() {
      if (!issue) {
        if (!active) return;
        setReaderState({
          isLoading: false,
          canRead: false,
          error: "Magazine issue not found."
        });
        return;
      }

      if (issue?.is_free) {
        if (!active) return;
        setReaderState({
          isLoading: false,
          canRead: true,
          error: ""
        });
        pushRecentRead(issue);
        return;
      }

      const token = localStorage.getItem("token");
      if (!token) {
        if (!active) return;
        setReaderState({
          isLoading: false,
          canRead: false,
          error: "Please log in and purchase this issue or subscribe to read it."
        });
        return;
      }

      try {
        const response = await makeAPI("/api/get_magazine_access", "POST", true, {
          issue_id: issue?._id
        });

        if (!active) return;

        if (response?.status !== "S" || !response?.data?.can_read_issue) {
          setReaderState({
            isLoading: false,
            canRead: false,
            error: "You do not have access to this magazine issue."
          });
          return;
        }

        setReaderState({
          isLoading: false,
          canRead: true,
          error: ""
        });
        pushRecentRead(issue);
      } catch {
        if (!active) return;
        setReaderState({
          isLoading: false,
          canRead: false,
          error: "Unable to validate magazine access right now."
        });
      }
    }

    validateReaderAccess();

    return () => {
      active = false;
    };
  }, [issue]);

  return (
    <div>
      {readerState.isLoading ? (
        <div className="container py-5">
          <div className="magazine-panel text-center p-5">Validating your magazine access...</div>
        </div>
      ) : null}

      {!readerState.isLoading && readerState.canRead ? <MagazineReader issue={issue} /> : null}

      {!readerState.isLoading && !readerState.canRead ? (
        <div className="container py-5">
          <div className="magazine-panel text-center p-5">
            <h2 className="mb-3">Access Required</h2>
            <p className="mb-4">{readerState.error}</p>
            <button
              type="button"
              className="btn magazine-btn magazine-btn--primary"
              onClick={() => navigate("/magazine")}
            >
              Back to Magazine
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
}
